import React, { forwardRef, useCallback, useEffect, useState } from "react";
import {
    Button,
    Slide,
    TextField,
} from "@material-ui/core";
import { Redirect, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions as authActions } from "../Auth/_redux/authRedux";
import {
    loginWithMobile,
    VerifyLogin,
} from "../Homepage/pages/widgets/components/cruds";
import { useMediaQuery } from "react-responsive";
import ReactLoading from "react-loading";
import ReactCodeInput from "react-code-input";
import CounterProgress from "./CounterProgress";
import AuthModal from "./AuthModal";
import "./Auth.css"

const Login = (props) => {
    let { state: authState } = useSelector((state) => ({
        state: state.auth,
    }));
    const isAuthorized = authState.user ? true : false;
    const history = useHistory();
    const [codeValue, setCodeValue] = useState(null);
    const [phoneValue, setPhoneValue] = useState(null);
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const [verifyTime, setVerifyTime] = useState(false);
    const [errMessage, setErrMessage] = useState(false);
    const [isPinLoading, setIsPinLoading] = useState(false);
    const [codeErrMessage, setCodeErrMessage] = useState(null);
    const [open, setOpen] = useState(null);
    const [showLoginLink, setShowLoginLink] = React.useState(false);
    const [phoneErr, setPhoneErr] = useState(null);
    const phoneValidation = /^09\d{9}$/;
    const propsz = {
        className: "class-Input ",
        inputStyle: {
            textAlign: "center",
            fontFamily: "sans",
            borderRadius: "6px",
            border: "1px solid lightgrey",
            boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
            margin: "4px",
            paddingLeft: "8px",
            paddingRight: "0px",
            width: "10%",
            height: "42px",
            fontSize: "32px",
            boxSizing: "border-box",
            color: "black",
            backgroundColor: "white",
            direction: "ltr",
            flexGrow: 1,
        },
        touch: {
            border: "1px solid green",
        },
        inputStyleInvalid: {
            fontFamily: "monospace",
            margin: "4px",
            MozAppearance: "textfield",
            width: "15px",
            borderRadius: "3px",
            fontSize: "14px",
            height: "26px",
            paddingLeft: "7px",
            backgroundColor: "red",
            color: "red",
            border: "1px solid red",
        },
    };

    const dispatch = useDispatch();

    const loginHandler = () => {
        const data = {
            phone: `${+phoneValue[0] === 0 ? phoneValue : `0${phoneValue}`}`,
        };
        setIsLoginLoading(true);
        loginWithMobile(data)
            .then((res) => {
                setVerifyTime(true);
                setIsLoginLoading(false);
                setErrMessage(null);
            })
            .catch((err) => {
                setIsLoginLoading(false);
                if (err.response.data.status === 403) {
                    setErrMessage(err.response.data.message);
                } else if (err.response.data.status === 404) {
                    setErrMessage("کاربری با شماره تلفن وارد شده یافت نشد");
                    setShowLoginLink(true)
                } else {
                    setErrMessage("مشکلی در ارتباط با سرور بوجود آمد");
                }
            });
    };

    const loginVerifier = (code = null) => {
        let codeValueTemp = codeValue
        if (code != null) {
            codeValueTemp = code;
        }
        const data = {
            phone: phoneValue,
            code: codeValueTemp,
        };

        setIsPinLoading(true);

        VerifyLogin(data)
            .then((res) => {
                setIsPinLoading(false);
                const date = new Date();
                date.setDate(date.getDate() + 1);
                const dateOBJ = { date };
                localStorage.setItem("tokenExpireTime", JSON.stringify(dateOBJ));
                dispatch(authActions.login(res.data.data));
                window.localStorage.setItem(
                    "userInformation",
                    JSON.stringify(res.data.data)
                );
                if (props.buyTicketHandler) {
                    props.buyTicketHandler(res);
                }
                history.push("/");
            })
            .catch((err) => {
                setIsPinLoading(false);
            });
    };

    const componentChangeHandler = (type, value) => {

        switch (type) {
            case "code":

                return setCodeValue(value);
            case "mobile":
                return setPhoneValue(value);
        }
    };

    const resendCodeClick = () => {
        const data = {
            phone: `${+phoneValue[0] === 0 ? phoneValue : `0${phoneValue}`}`,
        };
        console.log("resend code ....", data.phone)
        // SignInWithMobile(data).then((res) =>
        //   setVerifyTime(true)
        // );
    };

    const handleClickOpen = () => {
        setOpen(true);
        setVerifyTime(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (isAuthorized) {
            return history.push("/")
        }
    }, [])

    return (
        <>
            {!verifyTime ? (
                <div className="d-flex justify-content-center">
                    <div
                        className="w-50 d-flex flex-column p-8 my-3 bg-white mt-15"
                        style={{ gap: "20px" }}
                    >
                        <span className="mx-auto my-2" style={{ fontSize: "20px" }} >ورود</span>
                        <p className="mx-auto my-3">
                            برای ادامه شماره موبایل خود را وارد کنید.
                        </p>
                        <TextField
                            className="w-75 mx-auto my-2"
                            variant="outlined"
                            onKeyUp={(e) => {
                                if (e.which === 13) {
                                    loginHandler();
                                }
                            }}
                            id="outlined-start-adornment"
                            placeholder="شماره تلفن"
                            onChange={(e) => {

                                if (phoneValidation.test(e.target.value)) {
                                    setPhoneErr(false);
                                    componentChangeHandler("mobile", e.target.value);
                                } else {
                                    setPhoneErr(true);
                                }
                            }}
                        />
                        <span className="mx-auto w-75 d-flex" style={{ color: "red" }}>
                            <i
                                className={`fa fa-exclamation-circle col-red mi-10 ${errMessage ? "d-block" : "d-none"
                                    }`}
                            ></i>
                            {errMessage}
                            {phoneErr ? (
                                <div className="text-danger">
                                    شماره وارد شده اشتباه میباشد
                                </div>
                            ) : null}
                        </span>
                        {showLoginLink ?
                            <div className="mx-auto w-75 d-flex" >
                                <AuthModal modal={"register"} open={open} handleClose={handleClose} phone={phoneValue} />
                                <i class="flaticon2-calendar-3 mi-10" style={{ color: "rgb(58 74 203)" }}></i>
                                <p >
                                    جهت ورود به سایت، لطفا
                                    <a style={{ color: "rgb(58 74 203)" }}
                                        onClick={() => {
                                            handleClickOpen();
                                            props.handleClose();
                                        }}
                                    > ثبت نام </a>
                                    کنید
                                </p>
                            </div>
                            : null}
                        <div className="d-flex my-3 mx-auto w-75 gap-10 justify-flex-end">
                            <Button
                                className="btn  mx-auto text-white border15 w-100"
                                style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#6dd06d",
                                    width: "34rem",
                                    height: "4rem",
                                    fontSize: "16px",
                                }}
                                onClick={() => {
                                    if (!phoneErr) { loginHandler(); }
                                }}
                            >
                                {isLoginLoading ? (
                                    <ReactLoading
                                        type={"spin"}
                                        color={"white"}
                                        height={"12%"}
                                        width={"12%"}
                                    />
                                ) : (
                                    "تایید و دریافت کد"
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="d-flex justify-content-center">
                    <div
                        className="w-50 d-flex flex-column p-8 my-3 bg-white mt-15"
                        style={{ gap: "20px" }}
                    >
                        <h2 className="mx-auto my-2">کد را وارد کنید</h2>
                        <p className="mx-auto w-75 " style={{ fontSize: "14px" }}>
                            کد 6 رقمی به شماره {phoneValue} ارسال شد.
                        </p>
                        <div
                            className="mx-auto w-75"
                            onKeyUp={(e) => {
                                if (e.which === 13) {
                                    loginVerifier();
                                }
                            }}
                        >
                            <ReactCodeInput
                                {...propsz}
                                type="number"
                                fields={6}
                                onChange={async (e) => {
                                    await componentChangeHandler("code", e);

                                    if (e != null && e.length == 6) {

                                        await loginVerifier(e)
                                    }
                                }}
                            />

                            <h5 className="mt-5 d-flex col-red">
                                <i
                                    style={{ color: "red", marginInline: "10px" }}
                                    className={`fa fa-exclamation-circle ${codeErrMessage ? "d-block" : "d-none"
                                        }`}
                                ></i>
                                {codeErrMessage}
                            </h5>
                        </div>
                        <CounterProgress handler={loginHandler} />

                        <div
                            className="d-flex my-3 mx-auto w-75"
                            style={{ justifyContent: "flex-end", gap: "10px" }}
                        >
                            <Button
                                className="btn  mx-auto text-white border15 w-100"
                                style={{
                                    whiteSpace: "nowrap",
                                    backgroundColor: "#6dd06d",
                                    width: "34rem",
                                    height: "4rem",
                                }}
                                onClick={() => {
                                    loginVerifier();
                                }}
                            >
                                {isPinLoading ? (
                                    <ReactLoading
                                        type={"spin"}
                                        color={"white"}
                                        height={"12%"}
                                        width={"12%"}
                                    />
                                ) : (
                                    "تایید"
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
};

export default Login
